import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { getCartPromo, removeFromCart, successPaidOrder } from '../actions/cartActions';
import HeaderCart from '../components/HeaderCart';
import Alert_promo from '../components/alert_promo';
import useAxios from '../axios/useAxios';
import PageLoader from '../components/loader/PageLoader';
import CartLength from '../components/CartLength';
import PrimaryButton from '../components/button/PrimaryButton';
import Checkout from '../payments/Checkout';
import { getConecsInstrument } from '../actions/userConecsActions';
import PromoCarte from '../components/promo_carte';
import {
  clearEdenred,
  getEdenredBalance,
  updateEdenred,
} from '../actions/userEdenredActions';
import StepBar from '../components/Step_bar';
import v from '../styles/img/arrow/v.svg';
import { selectPayment } from '../actions/payMethodActions';
import { findUser } from '../actions/userActions';
import BackButton from '../components/button/BackButton';
import { FIDCOUPON, PROMO, SCAN, SCAN_CHECK } from '../constants/routes';
import { formatPrice, formatPriceWithEuro } from '../utils/StringUtils';
import {
  hasFidelityCard, isAllowedToPay, isFullPaymentByJackpot, isStoreIntegrated, z,
} from '../utils/Validator';
import {
  USER_EDENRED_BALANCE_REQUEST,
  USER_EDENRED_BALANCE_TIMEOUT,
} from '../constants/userConstants';
import { getErrorMessage } from '../utils/WsUtils';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { notifyDoubleCallback, notifyError } from '../utils/Notify';
import SuccessNotif from '../components/SuccessNotif';
import { CheckoutProvider } from '../context/checkoutProvider';
import * as Sentry from '@sentry/react';
import PaymentLoader from '../components/loader/PaymentLoader';
import {

  CART_GOOGLE_PAY_PAYZEN_LOADING,
} from '../constants/cartConstants';
import { useNetworkQuality } from '../hooks/useNetworkQuality';
import { useFunnelTracking } from '../posthog/funnelTracking';
import { usePerformanceContext } from '../context/PerformanceContext.jsx';
import PhoneNumberSection from '../components/cart/PhoneNumberSection';
import CartTotalSection from '../components/cart/CardTotalSection';
import UsageConditions from '../components/cart/UsageConditions';
import { JackpotUnavailableModal } from '../components/jackpot/modal/JackpotUnavailableModal';
import {
  handleMatchPaymentWithJackpotError, matchPaymentWithJackpot,
} from '../payments/Jackpot/matchPaymentWithJackpot';
import SkeletonCartScreen from '../components/loader/SkeletonCartScreen';

const CartScreen = () => {
  window.scrollTo(0, 0);
  localStorage.setItem('promoSolde', false);

  const axiosInstance = useAxios();
  const navigate = useNavigate();
  const stripe = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

  const { loadingCart, cartItems, loadingPayment, googlePayPayzenLoading } =
    useSelector((state) => state.cart);
  const { store } = useSelector((state) => state.store);
  const user = useSelector((state) => state.user);
  const orderPay = useSelector((state) => state.orderPay);
  const dispatch = useDispatch();
  const edenred = useSelector((state) => state.user.edenred);
  const conecs = useSelector((state) => state.user.conecs);
  const [checkedValues, setCheckedValues] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [localQty, setLocalQty] = useState([]);
  const [localTotal, setLocalTotal] = useState();
  const countItems = CartLength();
  const [popupSuccess, setPopupSuccess] = useState(false);
  const [edenredErrorMessage, setEdenredErrorMessage] = useState('');
  const [edenredIsLoading, setEdenredIsLoading] = useState(false);
  const [validationLoaded, setValidationLoaded] = useState(false);
  const isPayzenModule = store?.paymentsGateway?.CB === 'payzen'; // TODO : rename
  const [isPayzenApplePayLoading, setIsPayzenApplePayLoading] =
    useState(isPayzenModule);

  const [loadingGooglePayPayzenLoading, setLoadingGooglePayPayzenLoading] =
    useState(googlePayPayzenLoading ?? false);

  const {
    isOnline: isOnlineNetworkInfo,
    isLoading: isLoadingNetworkInfo,
    isSlowConnection,
  } = useNetworkQuality({
                          // speedTestInterval: 45 * 1000,
                          runOnce: true,
                          enableSpeedTest: true,
                          testSizeKB: 500, // Size of test download
                          slowThresholdMbps: 2, // Threshold for slow/fast classification
                        });
  const { trackPageViewCart } = useFunnelTracking();
  const { markComplete } = usePerformanceContext();

  useEffect(() => {
    trackPageViewCart({});
  }, [trackPageViewCart]);

  useEffect(() => {
    const isPageFullyLoaded = !loadingCart &&
      validationLoaded &&
      !isPayzenApplePayLoading &&
      !edenredIsLoading &&
      !loadingGooglePayPayzenLoading;

    if (isPageFullyLoaded && cartItems && store && markComplete) {
      markComplete();
    }
  }, [
              loadingCart,
              validationLoaded,
              isPayzenApplePayLoading,
              edenredIsLoading,
              loadingGooglePayPayzenLoading,
              cartItems,
              store,
              markComplete,
            ]);

  function waitForDomElement(selector, status, callback) {
    function check() {
      const element = document.querySelector(selector);
      if (element) {
        const display = window.getComputedStyle(element).display;
        if (display === status) callback(element);
        else requestAnimationFrame(check);
      } else {
        requestAnimationFrame(check);
      }
    }

    check();
  }

  function waitForIframeValidation() {
    console.log('Cart Screen - waitForIframeValidation');
    const selectorIframValidation = '.kr-smart-form-iframe-container';

    waitForDomElement(selectorIframValidation, 'block', () => {
      waitForIframeFinishValidation();
    });
  }

  function waitForIframeFinishValidation() {
    console.log('Cart Screen - waitForIframeFinsihValidation');
    const selectorIframValidation = '.kr-smart-form-iframe-container';

    waitForDomElement(selectorIframValidation, 'none', () => {
      dispatch({ type: CART_GOOGLE_PAY_PAYZEN_LOADING, payload: true });
      console.log('Cart Screen - waitForIframeFinsihValidation dispatch');
    });
  }

  function closeGooglePayPopup(shadowRoot) {
    const iconCloseGooglePayPath =
      'div > div > div.modal.kr-modal-open.mobile > div.modal-header > i';
    const iconCloseGooglePay = shadowRoot.querySelector(iconCloseGooglePayPath);
    if (iconCloseGooglePay) {
      iconCloseGooglePay.click();
    }
  }

  function openValidationGooglePayPopup() {
    const buttonCardButtonPayzen = document.querySelector(
      '#pay-by-card-button',
    );
    if (buttonCardButtonPayzen) {
      buttonCardButtonPayzen.click();
    }
  }

  function handleGooglePayValidationDev(event) {
    const idKrGooglePayPath = '#kr-simulator-google-pay';
    const isInsideModal = event.target.closest(idKrGooglePayPath);

    if (isInsideModal) {
      const validateButtonPath =
        'div > div > div.modal.kr-modal-open.mobile > div.kr-footer.visible > button.kr-confirm.processing';
      const shadowRoot = document.querySelector(idKrGooglePayPath).shadowRoot;
      const payButton = shadowRoot.querySelector(validateButtonPath);

      if (!payButton) return;

      const pathFormModal = event.composedPath();

      if (pathFormModal.includes(isInsideModal)) {
        dispatch({ type: CART_GOOGLE_PAY_PAYZEN_LOADING, payload: true });

        closeGooglePayPopup(shadowRoot);
        openValidationGooglePayPopup();
        waitForIframeValidation();
      }
    }
  }

  function handleGooglePayValidationProd() {
    setLoadingGooglePayPayzenLoading(true);
    dispatch({ type: CART_GOOGLE_PAY_PAYZEN_LOADING, payload: true });

    openValidationGooglePayPopup();
    waitForIframeValidation();
  }

  useEffect(() => {
    const hostname = window.location.hostname;
    const handlerDev = (event) => handleGooglePayValidationDev(event, hostname);
    const handlerProd = (event) =>
      handleGooglePayValidationProd(event, hostname);

    const isToolkitEnabled = process.env.REACT_APP_TOOLKIT?.toUpperCase() === 'TRUE';
    const isDevOrStageEnv = process.env.NODE_ENV === 'development' || isToolkitEnabled;

    let interval;

    const checkSmartFormClick = () => {
      try {
        const smartFormClickStr = localStorage.getItem('smartFormClick');

        if (smartFormClickStr) {
          const smartFormClick = JSON.parse(smartFormClickStr);
          if (smartFormClick && smartFormClick.paymentMethod === 'GOOGLEPAY') {
            console.log('Cart Screen - HandleProd');
            handlerProd(smartFormClick);
            localStorage.removeItem('smartFormClick');
          }
        }
      } catch (error) {
        console.error('Error reading smartFormClick:', error);
      }
    };

    const storageListener = (e) => {
      if (e.key === 'smartFormClick') {
        console.log('Cart Screen - launch checkSmartFormClick');
        checkSmartFormClick();
      }
    };

    if (isDevOrStageEnv) {
      document.addEventListener('click', handlerDev, false);
    } else {
      localStorage.removeItem('smartFormClick');
      checkSmartFormClick();

      console.log('Cart Screen - AddListener storage');
      window.addEventListener('storage', storageListener);
      interval = setInterval(checkSmartFormClick, 500);
    }

    return () => {
      if (isDevOrStageEnv) {
        document.removeEventListener('click', handlerDev, false);
      } else {
        console.log('Cart Screen - removeListener storage');
        window.removeEventListener('storage', storageListener);
        if (interval) {
          clearInterval(interval);
        }
      }
    };
  }, []);

  useEffect(() => {
    setLoadingGooglePayPayzenLoading(googlePayPayzenLoading ?? false);
  }, [googlePayPayzenLoading]);

  useEffect(() => {
    if (edenred?.balance) {
      dispatch({ type: USER_EDENRED_BALANCE_REQUEST });
      setEdenredIsLoading(true);
      getEdenredBalance(axiosInstance, edenred, user._id)
        .then((response) => dispatch(updateEdenred(response.data)))
        .catch((error) => {
          Sentry.captureException(error);
          if (error?.response?.data?.errorCode === 'EDENRED_TIMEOUT') {
            dispatch({ type: USER_EDENRED_BALANCE_TIMEOUT });
          } else {
            dispatch(clearEdenred(error));
            setEdenredErrorMessage(getErrorMessage(error));
          }
        })
        .finally(() => setEdenredIsLoading(false));
    }
    if (conecs?.balance) {
      dispatch(getConecsInstrument(axiosInstance, conecs));
    }
    dispatch(selectPayment(''));
    window.scrollTo(0, 0);

    if (user && user._id) {
      dispatch(findUser(user, axiosInstance, navigate));
    }
  }, []);

  useEffect(async () => {
    if (cartItems && store) {
      axiosInstance
        .get(`apiws/validation-available/${store.id}`)

        .catch((error) => {
          console.error(error);
        })
        .then(async () => {
          const resultDispatch = await dispatch(getCartPromo(cartItems._id, user, axiosInstance));
          if (resultDispatch?.message === 'success') {
            setValidationLoaded(true);
          }
        })
        .finally(() => {
          if (!loadingCart) {
            // setValidationLoaded(true);
          }
        });
    } else {
      if (!loadingCart) {
        // setValidationLoaded(true);
      }
    }
  }, []);

  useEffect(() => {
    let total = 0;
    cartItems?.orderItems.map((item, index) => {
      total += item.price * (localQty[index] || item.Qty);
    });

    setLocalTotal(total);
  }, [localQty, cartItems]);

  const accumulation = (element, chiffre) => {

    element.classList.add('price_animation');
    setTimeout(() => {
      element.classList.remove('price_animation');
    }, 1000);
  };

  if (document.querySelector('.price')) {
    accumulation(
      document.querySelector('.price'),
      formatPrice(cartItems?.itemsPrice - cartItems?.promoPrice),
    );
  }

  const truncate = (str, n) => {
    return str.length > n ? str.slice(0, n - 3) + '...' : str;
  };

  const deletePopup = () => {
    let element = document.getElementById('deletePopup');
    if (element.style.visibility === 'hidden') {
      element.style.visibility = 'visible';
    } else {
      element.style.visibility = 'hidden';
    }
  };

  useEffect(() => {
    if (cartItems?.isPaid === true) {
      setPopupSuccess(true);
    }
  }, [cartItems]);

  // Reload the cart if pazyen data last more than 30 seconds
  useEffect(() => {
    let timer;

    if (isPayzenModule && !isFullPaymentByJackpot(cartItems)) {
      if (isPayzenApplePayLoading) {
        const isReloadCartLocalExist = JSON.parse(localStorage.getItem('reloadCartScreen'));
        if (isReloadCartLocalExist) {
          console.log('Cart Screen - isReloadCartLocalExist');
          if (timer) clearTimeout(timer);
          return;
        }

        if (isOnlineNetworkInfo && !isLoadingNetworkInfo) {
          const durationTimeout = isSlowConnection() ? 25 : 12;

          timer = setTimeout(() => {
            const title = 'Erreur Paiement';
            const description = 'Les options de paiement ont pris trop de temps à charger. La page va être rechargée.';

            localStorage.setItem('reloadCartScreen', JSON.stringify(true));
            console.log('Cart Screen - setReloadCartScreen');

            notifyError(title, description);
            setTimeout(() => {
              window.location.reload();
            }, 4 * 1000);
          }, durationTimeout * 1000);
        }
      } else {
        if (timer) clearTimeout(timer);
        localStorage.removeItem('reloadCartScreen');
        console.log('Cart Screen - remove reloadCartScreen');
      }
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isPayzenModule, isPayzenApplePayLoading, isOnlineNetworkInfo, isLoadingNetworkInfo]);

  const isAllowedToPurchase = isAllowedToPay(cartItems);

  const onBack = () => {
    if (isStoreIntegrated(store) && hasFidelityCard(user)) navigate(FIDCOUPON);
    else if (!store?.permissions?.promo) navigate(SCAN);
    else navigate(PROMO);
  };

  // Init Jackpot Match
  const hasJackpotMatch = cartItems?.jackpot?.amount > 0;
  const hasPromo = cartItems.promoPrice !== cartItems.itemsPrice;
  const isJackpotMatchUsable = cartItems?.jackpot?.isAvailable &&
    cartItems?.jackpot?.isActive && cartItems?.jackpot?.amount > 0;

  console.info({ isJackpotMatchUsable });

  const orderId = cartItems?._id;
  const jackpot = cartItems?.jackpot;

  let isFullJackpotPaiement = false;

  const [isLoadingJackpotMatch, setIsLoadingJackpotMatch] = useState(false);
  const [isJackpotMatchUnavailableModal, setIsJackpotMatchUnavailableModal] = useState(false);

  if (isJackpotMatchUsable && hasJackpotMatch) {
    if (hasPromo) isFullJackpotPaiement = cartItems?.jackpot?.amount >= cartItems.promoPrice;
    else isFullJackpotPaiement = cartItems?.jackpot?.amount >= cartItems.itemsPrice;
  }

  const handleJackpotMatchPaiement = async () => {
    console.info('Cart Screen - handleJackpotMatchPaiement');
    setIsLoadingJackpotMatch(true);
    axiosInstance
      .get(`apiws/validation-available/${store.id}`)
      .then(async () => {
        try {
          const result = await matchPaymentWithJackpot(cartItems, user, axiosInstance);
          if (result?.status === 'success') {
            const data = {
              order: { ...cartItems, isPaid: true },
            };
            dispatch(successPaidOrder(data));
          }
        } catch (e) {
          const errorData = e.response.data;
          handleMatchPaymentWithJackpotError(errorData);
          setIsLoadingJackpotMatch(false);
        }
      })
      .catch((e) => {
        console.error(e);
        setIsJackpotMatchUnavailableModal(true);
      });

  };
  // END Jackpot Match

  const shouldHideCart = isFullJackpotPaiement && isJackpotMatchUsable
  ? (loadingCart || !validationLoaded)
  : (loadingCart || !validationLoaded || isPayzenApplePayLoading);

  return (
    <>
      {loadingGooglePayPayzenLoading &&
        <PaymentLoader title="Attente de validation de paiement" />
      }

      {!cartItems || !store ? (
        <PageLoader />
      ) : (
        <>
          {cartItems === undefined || store === undefined ? (
            <>{navigate('/')}</>
          ) : (
            <>
              {popupSuccess ? (
                <>
                  <SuccessNotif
                    actioner={() => {
                      navigate(SCAN_CHECK);
                    }}
                  />
                </>
              ) : (
                <></>
              )}

              <PromoCarte />
              <div className="h-full overflow-auto cartscreen" id="cartscreen">

                <Alert_promo />
                <div className="global-header">
                  <BackButton onClick={onBack} />
                  <HeaderCart titre="Paiement" />
                </div>

                {shouldHideCart ? (
                  <></>
                ) : (
                  <StepBar step={2} />
                )}

                {cartItems && cartItems?.orderItems?.length === 0 ? (
                  <>
                    <div className="w-full h-full flex flex-col p-16 items-center gap-5">
                      <h1>Panier vide</h1>
                      <Link
                        className="cart_empty text-2xl text-center px-12 "
                        to="/scan"
                      >
                        Retour au scanner {'>'}
                      </Link>
                    </div>
                  </>
                ) : (
                  <>
                    {cartItems ? (
                      <>
                        {shouldHideCart ?
                          <SkeletonCartScreen />
                          : null}

                        {isJackpotMatchUsable && isJackpotMatchUnavailableModal ?
                          <JackpotUnavailableModal
                            isOpen={isJackpotMatchUnavailableModal}
                            orderId={orderId}
                            jackpot={jackpot}
                          /> : null}

                        <div
                          id="cartOrder"
                          className={`min-h-fit px-6${
                            shouldHideCart ? ' opacity-10 fixed w-10 transform left-[200vh]' : ''
                          }`}
                        >
                          <div className="flex justify-between items-center">
                            <div className="flex items-center">
                              {checkedValues.length > 0 ? (
                                <button
                                  className="border-none "
                                  onClick={deletePopup}
                                >
                                  <img
                                    className=" h-8 w-auto"
                                    src="https://firebasestorage.googleapis.com/v0/b/pikkopay.appspot.com/o/Webapp%2Fcart%2Fcart_delete.png?alt=media&token=e416fc1a-35c3-44d7-868d-8cced82b717e"
                                    alt="delete"
                                  />
                                </button>
                              ) : (
                                <></>
                              )}
                              {/* <p className="ml-8 mr-2">Tout sélectionner :</p>
                            <input
                              type="checkbox"
                              checked={selectAll}
                              onChange={handleSelectAllChange}
                            /> */}
                            </div>
                          </div>

                          <div
                            className="checkout_contenair"
                            style={{ fontFamily: 'Open Sans' }}
                          >
                            <details
                              className="checkout-details border border-solid border-gray-300 rounded-b-none rounded-tl-2xl rounded-tr-2xl">
                              <summary className="checkoutsummary">
                                <thead
                                  className=" text-[16px] font-light"
                                  style={{ fontFamily: 'open_sansregular' }}
                                >
                                <tr className="py-4 px-[6px]">
                                  <th>
                                    {countItems}{' '}
                                    {countItems > 1 ? 'Produits' : 'Produit'}
                                  </th>

                                  {hasPromo || hasJackpotMatch ? (
                                    <>
                                      <th />
                                      <th />
                                      <th className="flex items-center gap-[8px]">
                                        {hasPromo ?
                                          <span
                                            className="text-[16px] geomanistBook bg-[#f5202099] text-white rounded p-2"> - {formatPriceWithEuro(cartItems?.itemsPrice - cartItems?.promoPrice)}</span>
                                          : null}

                                        {isJackpotMatchUsable && hasJackpotMatch ?
                                          <span
                                            className="text-[16px] geomanistBook bg-[#ba38f799] text-white rounded p-2"> - {formatPriceWithEuro(cartItems?.jackpot?.amount)}</span>
                                          : null}
                                      </th>
                                    </>
                                  ) : null}

                                  <th>
                                    <img src={v} alt="" srcSet="" />
                                  </th>
                                </tr>
                                </thead>
                              </summary>
                              {cartItems?.orderItems.map((item, index) => {
                                return (
                                  <li key={index}>
                                    <div
                                      className="cart_list checkoutcartitems text-xl"
                                      style={{
                                        borderColor: item.CountInStock,
                                        fontFamily: 'Open Sans',
                                        fontWeight: 400,
                                      }}
                                    >
                                      <div className="flex items-center justify-center overflow-hidden">
                                        <img
                                          src={item.image}
                                          alt={item.image}
                                          className="object-contain"
                                          style={{
                                            height: '50px',
                                            width: '50px',
                                          }}
                                        ></img>

                                        <div className="pr-4 py-4 ml-4">
                                          <div className="min-30 text-left ">
                                            <div className="mb-1 flex flex-nowrap">
                                              {truncate(item.name, 26)}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="itemcartpricesmall text-black flex column ">
                                        <span className="text-black">
                                          Qté:{item.Qty}
                                        </span>
                                        <div className="price flex">
                                          {formatPriceWithEuro(
                                            item.promoPrice || item.price,
                                          )}
                                          {item.promoPrice && item.price && (
                                            <span className="promotion_sliced">
                                              {formatPriceWithEuro(item.price)}
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                );
                              })}
                            </details>

                            <CartTotalSection cartItems={cartItems} isJackpotMatchUsable={isJackpotMatchUsable} />

                            {/*{!user?._id && <PhoneNumberSection />}*/}
                            <UsageConditions />
                          </div>

                          {isFullJackpotPaiement && isJackpotMatchUsable ? (
                            <div className="flex justify-center items-center">
                              <PrimaryButton
                                label="Finaliser ma commande"
                                className="w-full mt-4"
                                onClick={handleJackpotMatchPaiement}
                                disabled={isLoadingJackpotMatch}
                                isLoading={isLoadingJackpotMatch}
                              />
                            </div>
                          ) : (
                            <>
                              {!!cartItems && validationLoaded && (
                                <CheckoutProvider>
                                  <Elements stripe={stripe}>
                                    <Checkout
                                      edenredErrorMessage={edenredErrorMessage}
                                      setEdenredErrorMessage={
                                        setEdenredErrorMessage
                                      }
                                      edenredIsLoading={edenredIsLoading}
                                      promoLoaded={validationLoaded}
                                      isPayzenApplePayLoading={
                                        isPayzenApplePayLoading
                                      }
                                      setIsPayzenApplePayLoading={
                                        setIsPayzenApplePayLoading
                                      }
                                    />
                                  </Elements>
                                </CheckoutProvider>
                              )
                              }
                            </>
                          )}

                          {/* {!!cartItems && validationLoaded && !isFullJackpotPaiement && ( */}

                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          id="loader"
                          className="loader loader-default is-active"
                          data-text="Chargement des données"
                        ></div>
                      </>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default CartScreen;
